import type { User } from 'firebase/auth';
import { shouldTreatAsOnboardingComplete } from '../onboardingAccountState';
import { parseSafeLoginNextPath } from './safeLoginNextPath';

/**
 * After login, honor allowlisted `next` only for onboarded creators.
 */
export function resolveLoginDestination(
  windowSearch: string,
  postAuthRoute: string,
  userDoc: Record<string, unknown> | null,
  authUser: User | null | undefined,
): string {
  const next = parseSafeLoginNextPath(windowSearch);
  if (!next) return postAuthRoute;
  const role = (userDoc?.userType as string | undefined) ?? (userDoc?.role as string | undefined);
  const creator = role === 'creator' || role === 'influencer';
  if (!creator || !authUser) return postAuthRoute;
  if (!shouldTreatAsOnboardingComplete(authUser, userDoc)) return postAuthRoute;
  return next;
}
